import styled, { keyframes } from 'vue-styled-components';

import { COLORS } from '../../colors';

const bounceDelay = keyframes`
  0% {
    bottom: 0;
  }
  16.66% {
    bottom: 40px;
  }
  33.33% {
    bottom: 0;
  }
  50% {
    bottom: 40px;
  }
  66.66% {
    bottom: 0;
  }
  83.33% {
    bottom: 40px;
  }
  100% {
    bottom: 0;
  }
`;

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${COLORS.WHITE};
  z-index: 500;
`;

export const Spinner = styled.div`
  margin: 0 auto;
  width: 70px;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 45%;
`;

export const Ball = styled.div`
  background-color: ${COLORS.SILVER_CHALICE};
  position: relative;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: inline-block;
  margin: 2px;
  animation: ${bounceDelay} 3s infinite cubic-bezier(0.62, 0.28, 0.23, 0.99) both;

  &:nth-child(1) {
    animation-delay: -0.16s;
  }
  &:nth-child(2) {
    animation-delay: -0.08s;
  }
`;
